interface Props {
    text?: string
}

export default function Loading(props: Props) {
    return <p className="loading">{props.text ?? 'Loading...'}</p>
}
